import Container from '@material-ui/core/Container';
import Table from 'react-bootstrap/Table'

import SecondBox from './SecondBox';


const B2BInfoData = ({ b2bInfoData, clientData, selectedCountry }) => {
    const passwordChar = (password) => '•'.repeat(password.length);

    return (
        <Container>
            <div className="container-form-6">
                <SecondBox clientData={clientData.personal_data} selectedCountry={selectedCountry} />
                <br />
                <div className="row p-3">
                    <Table responsive hover size="sm" className="table-data">
                        <thead className="table-data table-head">
                            <tr>
                                <th>Portal B2B Cadena</th>
                                <th>Link portal B2B</th>
                                <th>Proveedor - Categoría (opcional)</th>
                                <th>Usuario</th>
                                <th>Contraseña</th>
                                <th>RUT o RUC Empresa</th>
                            </tr>
                            </thead>
                            <tbody>
                                {b2bInfoData.map((data, index) =>
                                    <tr className="table-data table-content" key={index + 1}>
                                        <td>{(data.portal || {}).portal_name || ''}</td>
                                        <td>{(data.portal || {}).portal_link || ''}</td>
                                        <td>{data.category || ''}</td>
                                        <td>{data.username || ''}</td>
                                        <td>{data.password || ''}</td>
                                        <td>{data.rut || ''}</td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Container>
    );
};

export default B2BInfoData;
